const WARNING = {
  icon: 'info',
  indicator: 'FEATURED'
}

const ERROR = {
  icon: 'close circular',
  indicator: 'ACTION_NEEDED'
}

const SUCCESS = {
  icon: 'check circular',
  indicator: 'CONFIRMED'
}

const STATUS = {
  WARNING,
  ERROR,
  SUCCESS
}

export default {
  STATUS
}
